<script setup>
import { onMounted, ref, watch } from 'vue';
import { useQuasar } from 'quasar';
import { InputSelect } from '@/components/inputs';
import Tr from '@/i18n/translation';
import { UserService } from '../../../services';
import { useBingoStore } from '@/stores/bingo/bingo.store';

const props = defineProps({
  clientId: {
    type: String,
    required: true,
  },
});

const quasar = useQuasar();
const bingoStore = useBingoStore();

const langList = Tr.supportedLocales;
const lang = ref(langList[0]);

watch(lang, async () => {
  bingoStore.resetLangData(lang.value);
  await bingoStore.tryGetLangData(lang.value);

  uploadRecords();
});

watch(
  () => bingoStore.clientData.lang[lang.value],
  async () => {},
);

function uploadRecords() {}

async function sendGKSData() {
  if (props.clientId) {
    const res = await UserService.sendBingoLangData(
      props.clientId,
      bingoStore.clientData.lang[lang.value],
      lang.value,
    );
    if (res) {
      quasar.notify({
        type: 'info',
        message: `Wysłano dane klienta`,
      });
    } else {
      quasar.notify({
        type: 'negative',
        message: `Błąd w przesyle danych`,
      });
    }
  } else {
    quasar.notify({
      type: 'negative',
      message: `Nie wybrano wszystkich pól`,
    });
  }
}

onMounted(() => {
  uploadRecords();
});
</script>

<template>
  <q-form ref="ClientForm" class="form" @submit.prevent="sendGKSData">
    <div class="send">
      <button class="core-default-form-button" type="submit">Wyślij</button>
    </div>
    <InputSelect
      v-model="lang"
      class="input"
      :select-options="langList"
      main-color="#84491f"
      background-color="#fffbf8"
      text-font="Raleway"
      >Język</InputSelect
    >
    <div class="inputs"></div>
  </q-form>
</template>

<style lang="scss" scoped>
@import '@/components/admin/form';
</style>
